import { useEffect } from 'react';
import { useLayout } from '../context/LayoutContext';

export const useNotFound = (value: boolean): void => {
  const { showNotFoundPage, hideNotFoundPage } = useLayout();

  useEffect(() => {
    if (value) {
      showNotFoundPage();
    } else {
      hideNotFoundPage();
    }

    return () => hideNotFoundPage();
  }, [value]);
};
